var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.452,
    height: 24.429,
    viewBox: "0 0 24.452 24.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "instagram-brands",
    d: "M12.154,37.776a6.263,6.263,0,1,0,6.268,6.263A6.256,6.256,0,0,0,12.154,37.776Zm0,10.335a4.072,4.072,0,1,1,4.075-4.072A4.081,4.081,0,0,1,12.154,48.111ZM20.14,37.52a1.462,1.462,0,1,1-1.462-1.461A1.458,1.458,0,0,1,20.14,37.52ZM24.291,39a7.227,7.227,0,0,0-1.975-5.119,7.285,7.285,0,0,0-5.122-1.973c-2.018-.114-8.068-.114-10.086,0a7.275,7.275,0,0,0-5.122,1.968A7.25,7.25,0,0,0,.011,39C-.1,41.014-.1,47.059.011,49.076a7.227,7.227,0,0,0,1.975,5.119,7.3,7.3,0,0,0,5.122,1.973c2.018.114,8.068.114,10.086,0a7.238,7.238,0,0,0,5.122-1.973,7.274,7.274,0,0,0,1.975-5.119C24.406,47.059,24.406,41.02,24.291,39ZM21.684,51.24a4.124,4.124,0,0,1-2.324,2.322c-1.609.638-5.428.491-7.206.491s-5.6.142-7.206-.491A4.124,4.124,0,0,1,2.624,51.24c-.638-1.608-.491-5.424-.491-7.2s-.142-5.6.491-7.2a4.124,4.124,0,0,1,2.324-2.322c1.609-.638,5.428-.491,7.206-.491s5.6-.142,7.206.491a4.124,4.124,0,0,1,2.324,2.322c.638,1.608.491,5.424.491,7.2S22.322,49.638,21.684,51.24Z",
    transform: "translate(0.075 -31.825)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.cf9009535ab7170116e0af32cad474d4.svg";
export { ForwardRef as ReactComponent };